import type { ReactNode } from 'react';

import { cx } from './cx';

/**
 * The small badge beside a card's title: how many rows are under it.
 *
 * Full radius rather than the pill's 3px, deliberately — it is a quantity, not a state, and
 * the two must not be mistaken for each other at a glance across a queue.
 */
export function Count({ className, children }: { className?: string; children?: ReactNode }) {
  return (
    <span
      className={cx(
        'text-caps font-semibold py-px px-[7px] rounded-full bg-surface-2 text-ink-2',
        className,
      )}
    >
      {children}
    </span>
  );
}
